import styled from 'styled-components';
import theme from '../../theme';

export const SubscriptionContainer = styled.div`
  margin-top: 16px;
  margin-left: 55px;
  margin-right: 60px;
  margin-bottom: 20px;
  border-radius: 10px;
  background-color: ${theme.colors.primary2};
  animation: fadeIn 0.3s ease-in-out;
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 667px) {
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 12px;
    margin-bottom: 16px;
  }
`;

export const Header = styled.header`
  padding-top: 20px;
  padding-bottom: 20px;
 
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  height: auto;
  color: ${theme.colors.title};
  display: block;

  @media (max-width: 667px) {
      font-size: 14px;
      margin-bottom: 8px;
      letter-spacing: 0.4px;
    }
`;

export const SubscriptionContent = styled.div`
  display: block;
  text-align: center;
  padding: 24px 20px 28px 20px;

  div {
    margin-bottom: 18px;

    &:last-of-type {
      margin-bottom: 8px;
    }
  }

  p,
  h5 {
    display: inline;
  }

  h5 {
    color: ${theme.colors.text};
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    line-height: 1.5;
    letter-spacing: 0.2px;

    @media (max-width: 667px) {
      font-size: 14px;
      display: block;
      margin-bottom: 4px;
      font-weight: 700;
    }
  }

  p {
    color: ${theme.colors.title};
    font-size: 15px;
    font-weight: 500;
    line-height: 1.6;
    text-align: center;
    padding-left: 8px;

    @media (max-width: 667px) {
      font-size: 13px;
      display: block;
      padding-left: 0;
      font-weight: 500;
    }

    &.text-danger {
      color: #b52b12;
    }

    &.text-success {
      color: #36ba14;
    }
  }
`;

export const TableHeaderMain = styled.header`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  margin-left: 55px;
  margin-right: 60px;
  margin-bottom: 16px;
  border-radius: 10px;
  background-color:${theme.colors.primary};
  align-items: center;
  color: ${theme.colors.title};
  font-weight: 800;
  font-style: normal;
  font-size: 20px;
  letter-spacing: 0.5px;
  padding: 14px 0;

  @media (max-width: 667px) {
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 20px;
    margin-bottom: 16px;
    font-size: 17px;
    padding: 12px 0;
    letter-spacing: 0.3px;
  }
`;

export const TableContainer = styled.div`
  margin-top: 0;
  margin-left: 55px;
  margin-right: 60px;
  margin-bottom: 24px;
  border-radius: 10px;
  padding: 8px;
  background: ${theme.colors.primary2};
  border-radius: 10px;
  animation: fadeIn 0.4s ease-in-out 0.1s both;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 667px) {
    margin-left: 16px;
    margin-right: 16px;
    margin-bottom: 20px;
    padding: 0;
    background: transparent;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  display: block;

  td {
    padding: 0.75rem;
    text-align: center;
  }
`;

export const TableHeader = styled.thead`
  display: none;
`;

export const TableBody = styled.tbody`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  padding: 0;

  tr {
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(180, 180, 194, 0.15);
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);
    padding: 20px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, ${theme.colors.primary} 0%, rgba(${theme.colors.primary}, 0.5) 100%);
    }

    &:hover {
      border-color: ${theme.colors.primary};
      box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.15);
      transform: translateY(-4px);
    }
  }

  td {
    padding: 0;
    margin-bottom: 12px;
    text-align: left;
    font-style: normal;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.7;
    color: ${theme.colors.title};
    border: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    &:nth-child(1)::before {
      content: '#';
      font-weight: 800;
      color: rgba(${theme.colors.title}, 0.5);
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      min-width: 30px;
    }

    &:nth-child(2)::before {
      content: 'Data';
      font-weight: 800;
      color: rgba(${theme.colors.title}, 0.5);
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      min-width: 30px;
    }

    &:nth-child(3)::before {
      content: 'Plano';
      font-weight: 800;
      color: rgba(${theme.colors.title}, 0.5);
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      min-width: 30px;
    }

    &:nth-child(4)::before {
      content: 'Valor';
      font-weight: 800;
      color: rgba(${theme.colors.title}, 0.5);
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      min-width: 30px;
    }

    &:nth-child(5)::before {
      content: 'Método';
      font-weight: 800;
      color: rgba(${theme.colors.title}, 0.5);
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      min-width: 30px;
    }

    &:nth-child(6)::before {
      content: 'Status';
      font-weight: 800;
      color: rgba(${theme.colors.title}, 0.5);
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      min-width: 30px;
    }

    &:nth-child(7)::before {
      content: 'Ação';
      font-weight: 800;
      color: rgba(${theme.colors.title}, 0.5);
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      min-width: 30px;
    }
  }

  a {
    color: ${theme.colors.primary};
    text-decoration: none;
    font-weight: 700;
    font-size: 13px;
    padding: 7px 14px;
    border-radius: 6px;
    background: rgba(${theme.colors.primary}, 0.1);
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
      background: ${theme.colors.primary};
      color: white;
      font-weight: 700;
    }
  }

  .text-success {
    color: #36ba14;
    font-weight: 700;
    background-color: rgba(54, 186, 20, 0.12);
    padding: 6px 12px;
    border-radius: 6px;
    display: inline-block;
    font-size: 12px;
  }

  .text-danger {
    color: #b52b12;
    font-weight: 700;
    background-color: rgba(181, 43, 18, 0.12);
    padding: 6px 12px;
    border-radius: 6px;
    display: inline-block;
    font-size: 12px;
  }

  .text-warning {
    color: #FBE306;
    font-weight: 700;
    background-color: rgba(251, 227, 6, 0.15);
    padding: 6px 12px;
    border-radius: 6px;
    display: inline-block;
    font-size: 12px;
  }

  .text-secondary {
    color: #CECECE;
    font-weight: 600;
  }

  @media (max-width: 667px) {
    grid-template-columns: 1fr;
    gap: 12px;

    tr {
      padding: 16px;

      &:hover {
        transform: translateY(0);
      }
    }

    td {
      font-size: 13px;
      margin-bottom: 10px;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;

      &:nth-child(1)::before,
      &:nth-child(2)::before,
      &:nth-child(3)::before,
      &:nth-child(4)::before,
      &:nth-child(5)::before,
      &:nth-child(6)::before,
      &:nth-child(7)::before {
        display: block;
        margin-bottom: 4px;
        min-width: auto;
      }
    }

    a {
      padding: 6px 12px;
      font-size: 12px;
      width: 100%;
      text-align: center;
    }
  }
`;

export const Loading = styled.div`
  align-items: center;
`;

export const Error = styled.div`
  margin: auto;
  font-size: medium;
  font-family:"Roboto", sans-serif;
  color: red;
  text-align: center;
`;
